import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class VisitorEnquiryApi {
  saveVisitorEnquiry = async (data) => {
    try {
      const response = await api.post("/visitor-enquiry", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Save Visitor Enquiry. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  getVisitorEnquiriesByExpo = async (expoId, search = "", page, limit = 10000, source = "", knownSource = "") => {
    try {
      const response = await api.get("/client/enquiries/visitor", {
        params: { expoId, search, page, limit, source, knownSource },
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Fetch Visitor Enquiries. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };
  updateVisitorStatus = async (id, payload) => {
    try {
      const response = await api.patch(`/visitor-enquiry/status/${id}`, payload);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Update Status. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  updateVisitor = async (id, data) => {
    try {
      const response = await api.put(`/visitor-enquiry/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Update Visitor. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  getVisitorBookedList = async (params) => {
    try {
      const response = await api.get("/visitor-enquiry/booked-list", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Fetch Booked Visitors. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  downloadVisitorBookedExcel = async (params) => {
    try {
      const response = await api.get("/visitor-enquiry/booked-list", {
        params: { ...params, format: "excel" },
        responseType: "blob",
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Download Excel. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  getTodayFollowups = async (params) => {
    try {
      const response = await api.get("/visitor-enquiry/today-followups", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Fetch Today Followups. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  downloadVisitorEnquiriesExcel = async (expoId, search = "", source = "", knownSource = "") => {
    try {
      let apiSource = "";
      if (source === "Website") apiSource = "website";
      else if (source === "Admin-app") apiSource = "mobile-admin";
      else if (source === "User-app") apiSource = "user-app";

      const response = await api.get("/client/enquiries/visitor", {
        params: { expoId, search, source: apiSource, knownSource, format: "excel" },
        responseType: "blob",
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Download Excel. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  sendBulkVisitorSMS = async (payload) => {
    try {
      const response = await api.post("/visitor-enquiry/send-bulk-sms", payload);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Send SMS. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const visitorEnquiryApi = new VisitorEnquiryApi();
export default visitorEnquiryApi;

export const {
  saveVisitorEnquiry,
  getVisitorEnquiriesByExpo,
  updateVisitorStatus,
  updateVisitor,
  getVisitorBookedList,
  downloadVisitorBookedExcel,
  downloadVisitorEnquiriesExcel,
  getTodayFollowups,
  sendBulkVisitorSMS
} = visitorEnquiryApi;
